import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cookie from 'react-cookie'
import trans from 'counterpart'

class CookieWallBlock extends Component {
  state = {
    isMount: false,
    cookiesAccepted: false
  }

  componentDidMount = () => {
    this.setState({
      isMount: true,
      cookiesAccepted: cookie.load('cookiesAccepted')
    })
  }

  handleAccept = () => {
    this.setState({ cookiesAccepted: true })
    cookie.save('cookiesAccepted', true, { path: '/' })
  }

  render = () => {
    const { block, accepted, manageTags } = this.props

    // We only display this block when rendered on client side, since we do not have access to the cookie on server side.
    if (!this.state.isMount) return null

    if (this.state.cookiesAccepted) return null

    return (
      <div className='alert alert-cookie fixed-bottom fade show' style={{ display: accepted ? 'none' : 'block' }} {...manageTags}>
        <div className='container d-flex'>
          <div dangerouslySetInnerHTML={{ __html: block.value }} />

          <a className='btn btn-white add-cookiewall' title='close' onClick={this.handleAccept}>
            {trans('button.close')}
          </a>
        </div>
      </div>
    )
  }
}

CookieWallBlock.propTypes = {
  accepted: PropTypes.bool,
  block: PropTypes.object,
  manageTags: PropTypes.object
}

export default CookieWallBlock
